
import "@sparta.deposits-v6.modules/debit-card-page-module/dist/styles.css"


import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import spartaRegisterSwUtility from "@sparta.global.utilities/sparta-register-sw-utility/dist/es6.js"

import "@sparta.deposits-v6.modules/debit-card-page-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.deposits-v6.shared-components/page-layout",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/deposits-v6-page-layout-es6" */ "@sparta.deposits-v6.shared-components/page-layout/dist/es6.js" )}
    },
    {
      name: "@sparta.deposits-v6.shared-components/typography",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/deposits-v6-typography-es6" */ "@sparta.deposits-v6.shared-components/typography/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-svg",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-svg-es6" */ "@sparta.global.shared-components/spa-vue-svg/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-badging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-badging-es6" */ "@sparta.global.shared-components/spa-vue-badging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-button",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-button-es6" */ "@sparta.global.shared-components/spa-vue-button/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-tooltip",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-tooltip-es6" */ "@sparta.global.shared-components/spa-vue-tooltip/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-ui-layers",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-ui-layers-es6" */ "@sparta.global.shared-components/spa-vue-ui-layers/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-card",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-card-es6" */ "@sparta.global.shared-components/spa-vue-card/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-modal",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-modal-es6" */ "@sparta.global.shared-components/spa-vue-modal/dist/es6.js" )}
    },
    {
      name: "@sparta.deposits-v6.shared-components/page-section",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/deposits-v6-page-section-es6" */ "@sparta.deposits-v6.shared-components/page-section/dist/es6.js" )}
    },
    {
      name: "@sparta.deposits-v6.shared-components/footnotes",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/deposits-v6-footnotes-es6" */ "@sparta.deposits-v6.shared-components/footnotes/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-squeezebox",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-squeezebox-es6" */ "@sparta.global.shared-components/spa-vue-squeezebox/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-spinner",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-spinner-es6" */ "@sparta.global.shared-components/spa-vue-spinner/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-messaging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-messaging-es6" */ "@sparta.global.shared-components/spa-vue-messaging/dist/es6.js" )}
    },
    {
      name: "@sparta.deposits-v6.shared-components/engagement-template",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/deposits-v6-engagement-template-es6" */ "@sparta.deposits-v6.shared-components/engagement-template/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-picture",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-picture-es6" */ "@sparta.global.shared-components/spa-vue-picture/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-link",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-link-es6" */ "@sparta.global.shared-components/spa-vue-link/dist/es6.js" )}
    },
    {
      name: "@sparta.deposits-v6.shared-components/chunked-grid-template",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/deposits-v6-chunked-grid-template-es6" */ "@sparta.deposits-v6.shared-components/chunked-grid-template/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es6.js" )}
    }
  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  secureLinkUtility.run()
await spartaBootstrapUtility.init(arguments);
spartaRegisterSwUtility.init();
  console.log('after - execute boot functions')
})();
